<!--
  --
  -- フライト入力シート
  --
  -->
<template>
  <c-base-sheet>
    <!-- ラベル -->
    <template #caption>{{caption}}</template>

    <!-- 説明 -->
    <template #description>
      <span v-html="flights.desc"/>
    </template>

    <!-- コンテンツ -->
    <template>
      <c-flight-input :flights="flights"/>
    </template>
  </c-base-sheet>
</template>

<script>
import CBaseSheet from '../CBaseSheet'
import CFlightInput from './CFlightInput'

export default {
  name: 'CFlightSheet',
  components: {
    CBaseSheet,
    CFlightInput
  },

  props: {
    caption: {
      type: String
    },

    flights: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    decided: true
  })
}
</script>
